import { SecondaryColors } from '@/utils/constants';

export const blueMenuBar = ({ bottom = '-10px', hoverWidth = 'calc(100% - 28px)' }: any = {}) => ({
  '&:after': {
    left: '50%',
    width: 0,
    bottom,
    height: '2px',
    content: '""',
    opacity: 0,
    position: 'absolute',
    backgroundColor: SecondaryColors.main,
    transform: 'translateX(-50%)',
    transition: 'all 150ms ease-in-out',
  },
  '&:hover:after': {
    opacity: 1,
    width: hoverWidth,
  },
});
